<template>
    <component :is="tag">
        <slot
            :proposalStep="step"
            :campaign="campaign"
            :proposal="proposal"
            :go-next-step="goNextStep"
            :go-previous-step="goPreviousStep"
            :patch-proposal-step="patchProposalStep"
            :isLoading="isLoading"
            :is-completing-proposal="isCompletingProposal"
            :is-patching-proposal="isPatchingProposal"
            :errors="errors"
            :errorMessage="errorMessage"
            :uses-alternate-terms="usesAlternateTerms"
        />
    </component>
</template>

<script>
    import BaseProposalStepMixin from '../mixins/BaseProposalStepMixin';
    import {NAME_CONTENT_AGREEMENT} from '../../../constants/proposal-steps';
    import get from 'lodash/get';

    export default {
        name:   'ProposalAgreementsProvider',
        mixins: [
            BaseProposalStepMixin,
        ],
        computed: {
            step(){
                return this.proposalSteps[NAME_CONTENT_AGREEMENT];
            },
            usesAlternateTerms() {
                return get(window.SERVER_DATA, 'alternate_terms_of_service', false);
            },
        },
        created() {
            this.isLoading = true;

            this.loadContact()
                .then(() => {
                    return Promise.all([
                        this.loadCampaign(),
                        this.loadProposal(),
                    ]);
                })
                .then(() => {
                    this.initProposalStep(this.step);
                })
                .catch(error => this.handleHttpError(error))
                .then(() => {
                    this.isLoading = false;
                });
        },
    };
</script>

<style scoped>

</style>
